/**
 * Universal Builder — read CLI slot metadata (starting runs moved to the room: Do / runs — the workbench
 * ``POST …/builder/runs`` was removed 2026-10-16, it had no caller).
 */
import { getRestApiBearerToken } from './apiToken';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'https://api.stepflow.dev';

/**
 * @param {string} networkId
 * @param {string} runId
 * @param {string} [poolId] room context — required for the backend room-level
 *   read gate (only room OWNER/BUILDER, or workspace OWNER/ADMIN, may read the
 *   builder prompt metadata). Always pass it from a room.
 */
export async function fetchBuilderCliSlot(networkId, runId, poolId) {
  const token = getRestApiBearerToken();
  if (!token) throw new Error('Not authenticated');
  const params = { runId };
  if (poolId) params.poolId = poolId;
  const q = new URLSearchParams(params);
  const res = await fetch(
    `${API_BASE_URL}/networks/${encodeURIComponent(networkId)}/builder/cli-slot?${q}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    },
  );
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || data.message || `HTTP ${res.status}`);
  return data;
}
